var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 162,
    viewBox: "0 0 161 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_141_11074)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_11074)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_141_11074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2235 75.548L101.696 31.1919C102.099 29.6916 100.556 28.6025 99.3347 29.5888L53.6277 66.5284C52.6124 67.3476 53.0381 68.5733 54.3216 68.917L86.2285 77.7744C87.9794 78.2419 89.7673 77.2443 90.2235 75.548Z",
    fill: "#31BF5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5177 63.1913L59.0435 107.547C58.6419 109.048 60.184 110.137 61.4048 109.151L107.113 72.2094C108.127 71.3901 107.703 70.1661 106.418 69.8223L74.5126 60.9649C72.7617 60.4975 70.9739 61.4934 70.5177 63.1913Z",
    fill: "#FBB945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6909 66.0105L90.2252 75.5473C89.769 77.2453 87.9795 78.2412 86.2302 77.7737L68.0527 72.7282L70.5201 63.1913C70.9763 61.4934 72.7642 60.4975 74.5135 60.9649L92.6909 66.0105Z",
    fill: "#F9464C"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_141_11074",
    x: 0.0521603,
    y: 0.52608,
    width: 160.635,
    height: 160.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.4739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_11074"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_11074",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_11074"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_141_11074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.3174,
    height: 80.3174,
    fill: "white",
    transform: "translate(40.2109 29.2109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsvg2);
export default __webpack_public_path__ + "static/media/icon.svg-2.c6a0ec9dc8b65ffe67b150ac31e70367.svg";
export { ForwardRef as ReactComponent };